import React from "react"
import { Sponsor } from "src/openapi"

import { Box, Image } from "src/UILibrary"

type Props = {
  item: Sponsor
}

export const SponsorItem = ({ item }: Props) => {
  return (
    <Box
      sx={{ p: "1.25rem  0.625rem", height: "100%", ":hover": { opacity: 0.8, cursor: "pointer" } }}
      onClick={() => window.open(item.companyUrl, "_blank")}
    >
      <Image
        src={item.companyLogo as string}
        sx={{ display: "flex", width: "100%", height: "100%" }}
        alt=""
        imageStyle={{ width: "100%", height: "100%", my: "auto", objectFit: "contain" }}
      />
    </Box>
  )
}
